import React from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "./ui/dialog";

/**
 * Poster with a play button that opens a YouTube player in a modal.
 */
export default function VideoModal({ videoId, poster, label = "Watch", className = "", aspect = "aspect-video" }) {
  const [open, setOpen] = React.useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          className={`group relative ${aspect} w-full overflow-hidden bg-sc-black ${className}`}
        >
          <img src={poster} alt={label} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-500" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-20 h-20 rounded-full bg-sc-lime/95 flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
              <Play className="w-8 h-8 text-sc-green fill-sc-green ml-1" />
            </span>
          </span>
          <span className="absolute bottom-4 left-4 font-mono2 uppercase tracking-widest text-xs text-sc-cream bg-black/40 px-3 py-1 backdrop-blur">
            {label}
          </span>
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl p-0 bg-black border-sc-lime/30 overflow-hidden">
        <DialogTitle className="sr-only">{label}</DialogTitle>
        <div className="aspect-video w-full">
          {open && (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
              title={label}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
